/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type withWidgetData_report = {|
  +groupByLocation: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "withWidgetData_report",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "groupByLocation",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "notifyPhantomWhenMounted_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CopyWidgetsDialog_report",
      "args": null
    }
  ],
  "type": "Report"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/withWidgetData/__generated__/withWidgetData_report.graphql.js